/**
 * @generated SignedSource<<42834b327acf53a030c6e72ec636bfd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationReadInput = {
  activityFeedbackId?: string | null | undefined;
  clientFormId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  groupPostComment?: string | null | undefined;
  groupPostId?: string | null | undefined;
  id?: string | null | undefined;
};
export type NotificationBoxReadMutation$variables = {
  input: NotificationReadInput;
};
export type NotificationBoxReadMutation$data = {
  readonly notificationRead: {
    readonly notification: {
      readonly activityFeedbackId: string;
      readonly id: string;
    };
  } | null | undefined;
};
export type NotificationBoxReadMutation = {
  response: NotificationBoxReadMutation$data;
  variables: NotificationBoxReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NotificationReadPayload",
    "kind": "LinkedField",
    "name": "notificationRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Notification",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activityFeedbackId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationBoxReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationBoxReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fc8265515f873554bef5729889627405",
    "id": null,
    "metadata": {},
    "name": "NotificationBoxReadMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationBoxReadMutation(\n  $input: NotificationReadInput!\n) {\n  notificationRead(input: $input) {\n    notification {\n      id\n      activityFeedbackId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dbf8aa15250706a94ec9b0b6970d98b7";

export default node;
